import {
  createGuid,
  getDetails,
  getMessage,
  getPin,
  getTitle,
  updateGTM
} from '../../../map_utils/index'
import { AccordionContentType } from '../../../interfaces/index'

const AccordionContent = ({ content, setLocation, scrollToMap }: AccordionContentType) => {
  const title =
    content.status === 'Major' ? content.name : getTitle(content.status)
  // Function to move the map to marker location
  const handleClick = () => {
    setLocation(content.position)
    updateGTM('suburb filter', content.region, title)
    scrollToMap()
  }
  return (
    <div key={createGuid()} className="mb-5 wc-outages__accordion-content">
      <div className="wc-outages__accordion-icon">
        <img src={getPin(content.status)} />
      </div>
      <div>
        <h6 className="m0 wc-outages__accordion-title">{title}</h6>
        <p>{getMessage(content.planned_flag === "True")}</p>
        <p>{getDetails(content)}</p>
        <button onClick={handleClick} className="wc-outages__button--link">
          View more on map
        </button>
      </div>
    </div>
  )
}

export default AccordionContent
